import { options, title } from 'Containers/steps/Consts'
import { t } from 'i18next'
import { ManageSubscriptionStep, ManageSubscriptionStepId } from 'types/manageSubscriptionTypes'

export function getPauseSubscriptionSuccessStep(): ManageSubscriptionStep {
  return {
    id: ManageSubscriptionStepId.PauseSubscriptionSuccess,
    type: 'custom',
    allowNext: true,
    wordings: {
      title: t(`${ManageSubscriptionStepId.PauseSubscriptionSuccess}.${title}`)
    }
  }
}
